import React, { useState } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Loading from "../../../shared/Loading";
import CprStatusItem from "./cpr/CprStatusItem";
import * as API from "../api";

const propTypes = {
  scrollToView: PropTypes.func.isRequired,
  current: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};
CprStatusPage.prototype = propTypes;

function CprStatusPage(props) {
  let { id } = useParams();
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    (async () => {
      if (!props.current) {
        const cpr = await API.getCprById(id);
        props.dispatch({ type: "set_current_cpr", payload: cpr });
      }
      setTimeout(() => {
        setLoading(false);
      }, 400);
    })();
  }, [props.current]);

  return (
    <>
      {loading && <Loading message={"loading..."} />}
      {!loading && props.current && (
        <>
          <CprStatusItem
            key={props.current.id}
            notifications={props.notifications}
            scrollToView={(e, t) => props.scrollToView(e, t)}
            cpr={props.current}
            dispatch={props.dispatch}
            flash={(msg) => {
              console.log(msg);
            }}
          />
        </>
      )}
    </>
  );
}

export default CprStatusPage;
